import { useState } from "react";
import { post } from "../networking/RequestService";

function useSetProfileExportOption() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const setProfileExportOption = async (params = {}) => {
        setLoading(true);
        setError(null);

        const { profileId, option } = params;

        if (!profileId || !option) {
            const errorMessage = "Missing required parameters";
            setError(errorMessage);
            setLoading(false);
            return { error: errorMessage };
        }

        try {
            const response = await post({ fn: "setProfileExportOption", profileId: profileId, option: option });
            return { data: response.data };
        } catch (error) {
            const errorMessage = error?.response?.data?.text || error?.message || "An unexpected error occurred";
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { setProfileExportOption, loading, error };
}

export default useSetProfileExportOption;
